<template>
  <div class="form-group">
    <label>{{config.name}} <span v-if="config.required">*</span></label>
    <input type="text" :class="{ 'is-invalid': errors.length > 0}" v-on:keyup="updateText" class="form-control" />
    <div class="invalid-feedback" :class="{'d-block' : errors.length > 0}"  v-if="errors.length > 0" v-cloak>
      {{ errors[0] }}
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  config: Object,
  errors: Array,
})

const emit = defineEmits(['change']);
const updateText = (e) => {
  emit('change', e.target.value);
}
</script>